var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("section", { staticClass: "gray-area", attrs: { id: "content" } }, [
    _c("div", { staticClass: "container" }, [
      _c(
        "div",
        { staticClass: "row" },
        [
          _c("sdr-breadcrumbs", {
            attrs: { active_item: "fourth", module: _vm.modulo },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c("div", { staticClass: "row" }, [
        _c("div", { staticClass: "container shortcode travel-ideas" }, [
          _c(
            "h1",
            {
              staticClass: "idea-title",
              staticStyle: { "margin-bottom": "20px" },
            },
            [
              _vm._m(0),
              _vm._v(
                "\n                    " +
                  _vm._s(_vm.pleaseselectoverview[_vm.getCurrentLocale]) +
                  "\n                "
              ),
            ]
          ),
        ]),
        _vm._v(" "),
        _c(
          "form",
          {
            on: {
              submit: function ($event) {
                $event.preventDefault()
                return _vm.onSubmit($event)
              },
            },
          },
          [
            _c(
              "div",
              {
                staticClass: "col-sms-6 col-sm-8 col-md-9",
                attrs: { id: "main" },
              },
              [
                _c(
                  "div",
                  {
                    staticClass: "tab-container",
                    attrs: { id: "flight-features" },
                  },
                  [
                    _c("ul", { staticClass: "tabs" }, [
                      _c("li", { staticClass: "active" }, [
                        _c(
                          "a",
                          {
                            attrs: {
                              href: "#flight-details",
                              "data-toggle": "tab",
                            },
                          },
                          [
                            _vm._v(
                              _vm._s(
                                _vm.tab_flightdetails[_vm.getCurrentLocale]
                              )
                            ),
                          ]
                        ),
                      ]),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "tab-content" }, [
                      _c(
                        "div",
                        {
                          staticClass: "tab-pane fade in active",
                          attrs: { id: "flight-details" },
                        },
                        [
                          _vm.get_RebookingUsersSearchDataGetRebookingKey
                            .idTicketOutwards.length > 0
                            ? _c(
                                "div",
                                [
                                  _c("h2", [
                                    _vm._v(
                                      _vm._s(
                                        _vm.tab_header_flightdetailsoutward[
                                          _vm.getCurrentLocale
                                        ]
                                      ) + ":"
                                    ),
                                  ]),
                                  _vm._v(" "),
                                  _c("sdr-rebooking-bookingno-flightdetails", {
                                    attrs: {
                                      flight:
                                        _vm.get_RebookingGetRebookingKeyResults
                                          .outwardFlight,
                                      flightdirection: "outward",
                                      modulo: _vm.modulo,
                                      mode: "ownprices",
                                      whichcall: "getrebookingkey",
                                    },
                                  }),
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.get_RebookingUsersSearchDataGetRebookingKey
                            .idTicketReturn.length > 0
                            ? _c(
                                "div",
                                [
                                  _c("br"),
                                  _c("hr", {
                                    staticStyle: {
                                      "border-top": "1px solid #fdb714",
                                    },
                                  }),
                                  _c("br"),
                                  _vm._v(" "),
                                  _c("h2", [
                                    _vm._v(
                                      _vm._s(
                                        _vm.tab_header_flightdetailsreturn[
                                          _vm.getCurrentLocale
                                        ]
                                      ) + ":"
                                    ),
                                  ]),
                                  _vm._v(" "),
                                  _c("sdr-rebooking-bookingno-flightdetails", {
                                    attrs: {
                                      flight:
                                        _vm.get_RebookingGetRebookingKeyResults
                                          .inboundFlight,
                                      flightdirection: "return",
                                      modulo: _vm.modulo,
                                      mode: "ownprices",
                                      whichcall: "getrebookingkey",
                                    },
                                  }),
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _c("br"),
                        ]
                      ),
                    ]),
                  ]
                ),
                _vm._v(" "),
                _c("br"),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    staticClass:
                      "btn-large icon-check uppercase full-width sundairrebooking icon-check4",
                    attrs: { type: "submit" },
                  },
                  [_vm._v(_vm._s(_vm.proceed[_vm.getCurrentLocale]))]
                ),
              ]
            ),
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "sidebar col-sms-6 col-sm-4 col-md-3" },
          [_c("sdr-contact-box")],
          1
        ),
      ]),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("span", { staticClass: "index" }, [
      _c("i", { staticClass: "soap-icon-arrow-right circle" }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }